// Plafond des invitations (24/09/2026, décision d'Hicham) : le serveur refuse
// au-delà de 200 invitations envoyées sur 24 heures par recruteur (ajout,
// fichier, renvoi), et au-delà de 3 renvois au même candidat. Il dit le
// plafond et, pour les invitations, combien il en reste. Un fichier qui
// dépasserait le reste est refusé en entier.
export const estLimiteInvitations = (result) =>
  result?.data === "limiteInvitations" || result?.data === "limiteRenvois"

export const messageLimiteInvitations = (result) => {
  const plafond = Number(result?.plafond) || 0
  if (result?.data === "limiteRenvois") {
    return "Ce candidat a déjà été relancé " + plafond + " fois en 24 heures. Vous pourrez le relancer plus tard, au plus tard dans 24 heures."
  }
  const restant = Number(result?.restant) || 0
  return restant > 0
    ? "Limite de " + plafond + " invitations sur 24 heures : il vous en reste " + restant + " pour le moment. Réduisez votre liste ou réessayez plus tard."
    : "Limite de " + plafond + " invitations sur 24 heures atteinte. De nouvelles invitations seront possibles au fil des heures, au plus tard dans 24 heures."
}
